// extracted by mini-css-extract-plugin
export default {"btn-open-account":"ButtonLink_btn-open-account__hbBRw"};